import { createApi } from '@reduxjs/toolkit/query/react'

import envConfig from '~/configs/env'

import anonymizingFetchBaseQuery from './anonymizingBaseQuery'
import prepareAuthHeader from './headers'

const baseQuery = anonymizingFetchBaseQuery({
  baseUrl: envConfig.apiUrl,
  prepareHeaders: prepareAuthHeader
})

export type BaseQuery = typeof baseQuery

export const emptyRootAPI = createApi({
  reducerPath: 'api',
  baseQuery,
  endpoints: () => ({})
})
